interface TombstonesIconProps {
  className?: string
}

export default function TombstonesIcon({ className }: TombstonesIconProps) {
  return (
    <svg
      viewBox="0 0 80 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      {/* Left small tombstone */}
      <g className="empty-state-draw">
        <path
          d="M8 48 L8 28 Q8 22 14 22 L18 22 Q24 22 24 28 L24 48"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        {/* Cross on left tombstone */}
        <path
          d="M16 28 L16 38 M12 32 L20 32"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
      </g>

      {/* Center large tombstone */}
      <g className="empty-state-draw-delayed">
        <path
          d="M30 48 L30 18 Q30 8 40 8 Q50 8 50 18 L50 48"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        {/* RIP text area - simple lines */}
        <path
          d="M36 20 L44 20 M35 26 L45 26 M36 32 L44 32"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
      </g>

      {/* Right small tombstone - slightly tilted */}
      <g className="empty-state-draw-delayed-2">
        <path
          d="M58 48 L56 30 Q55 24 61 23 L65 22.5 Q71 22 72 28 L74 48"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        {/* Cross on right tombstone */}
        <path
          d="M65 28 L65 38 M61 32 L69 32"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
      </g>

      {/* Ground line */}
      <path
        d="M0 48 L80 48"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        className="empty-state-draw"
      />
    </svg>
  )
}
